import React from 'react';
import { useRouteParams } from '@/context/routeParamsContext';
import { useLoungeDescription } from '@/hooks/loungesHooks/loungesHelperHooks';

const LoungeDetailsOverview = () => {
  const { loungeId } = useRouteParams();

  const loungeDescription = useLoungeDescription(loungeId);
  return (
    <div>
      {loungeDescription && (
        <p
          id="lounge-overview-description"
          className="pad-3-b tw-border-b tw-border-gray-300"
        >
          {loungeDescription}
        </p>
      )}
    </div>
  );
};

export default LoungeDetailsOverview;
